import PageNotFound from '../components/PageNotFound'
import { getUserData } from '../utils'
import { include, ternary } from '../utils/javascript'

const withRouteAuth = (Component, validRoles) => {
  return props => {
    const { userData } = getUserData()
    const { roleId } = { ...userData }
    const isValid = include(validRoles, roleId)

    return <>{ternary(isValid, <Component {...props} />, <PageNotFound />)}</>
  }
}

export default withRouteAuth
